<div class="mb-4">
  <!--    <exam-patient-form-->
  <!--      (response)="responseForm($event)"-->
  <!--      [editItem]="item"-->
  <!--    ></exam-patient-form>-->
</div>

<div class="mb-4 flex justify-end">
  <button mat-raised-button class="btn-add" (click)="newItem()">
    Inserir
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="mt-4">
  <!-- Select de Status -->
  <div class="mb-4">
    <mat-form-field appearance="outline" class="w-full md:w-64">
      <mat-label>Status</mat-label>
      <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusChange($event.value)">
        @for (option of statusOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <!--    @if (checkPermission('pesquisar-paginado')) {-->
  <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
  <!--    }-->
  <div>
    @if (!loading) {
      <div>
        <table-list-exam
          [dataSource]="itemsList"
          [columns]="columns"
          (selectItem)="editItem($event)"
          (deleteItem)="deleteItem($event)"
        />
        <!--          @if (itemsList.length > 0) {-->
        <!--            <pagination-->
        <!--              [currentPage]="page"-->
        <!--              [pageSize]="rows"-->
        <!--              [totalRecords]="numberRows"-->
        <!--              (pageChanged)="pageChanged($event)"-->
        <!--            />-->
        <!--          }-->
      </div>
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</div>
